export const initialValues = {
  owner_comment: '',
};

export const mock = [
  {
    id: 1,
    name: 'owner_comment',
    fieldType: 'textarea',
    classes: 'h-60 max-h-[720px] min-w-72 sm:min-w-96',
    classNames: 'w-full',
    placeholder: 'Owner Comment',
  },
];
